import {
  GET_MEMO_SUCCESS,
  API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [], //Model Data ve Error
  error: {},
}

const memoModal = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_MEMO_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        error: {}
      }
    case API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false 
      }

    default:

      return state

  }
}

export default memoModal